// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  margin: 0;
}

body {
  color: var(--foreground);
  background-color: var(--background);
}

/* improved-canvas assumes the host app's global border-box reset
   (e.g. desktop modeler); without it the context pad entries
   render 46px instead of 36px (padding added to 28px box). */
*,
*::before,
*::after {
  box-sizing: border-box;
}

#root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modeler {
  display: flex;
  height: 100%;
}

.canvas {
  flex: 1;
}

.properties-panel {
  position: relative;
  border-left: 1px solid var(--border);
  flex-shrink: 0;
  overflow: hidden;
}

.task-testing {
  position: relative;
  border-left: 1px solid var(--border);
  flex-shrink: 0;
  overflow: hidden;
}

.resize-handle {
  position: absolute;
  top: 0;
  left: -5px;
  width: 10px;
  height: 100%;
  cursor: col-resize;
  z-index: 1000;
}

.resize-handle:hover {
  background: var(--ring);
}

.djs-minimap {
  display: none;
}`, "",{"version":3,"sources":["webpack://./demo/style.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;6DAE6D;AAC7D;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf","sourcesContent":["html,\nbody {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  color: var(--foreground);\n  background-color: var(--background);\n}\n\n/* improved-canvas assumes the host app's global border-box reset\n   (e.g. desktop modeler); without it the context pad entries\n   render 46px instead of 36px (padding added to 28px box). */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n#root {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.modeler {\n  display: flex;\n  height: 100%;\n}\n\n.canvas {\n  flex: 1;\n}\n\n.properties-panel {\n  position: relative;\n  border-left: 1px solid var(--border);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.task-testing {\n  position: relative;\n  border-left: 1px solid var(--border);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.resize-handle {\n  position: absolute;\n  top: 0;\n  left: -5px;\n  width: 10px;\n  height: 100%;\n  cursor: col-resize;\n  z-index: 1000;\n}\n\n.resize-handle:hover {\n  background: var(--ring);\n}\n\n.djs-minimap {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
